// extracted by mini-css-extract-plugin
export var audioPlayer = "_ks-0";